import * as React from 'react';
import {classes, style} from 'typestyle';

export interface TextScrollingProps {
  className?: string;
}

export interface TextScrollingState {
  scrolling: boolean;
  ltr: boolean;
  offset: number;
}

export class TextScrolling extends React.Component<TextScrollingProps, TextScrollingState> {
  private outer: HTMLDivElement;
  private inner: HTMLSpanElement;
  private interval: any;

  constructor(props) {
    super(props);
    this.state = { scrolling: false, ltr: false, offset: 0 };
  }

  render() {
    const { scrolling, ltr, offset } = this.state;

    const styles = scrolling
      ? {
        transform: `translate3d(-${ltr ? offset : 0}px, 0, 0)`,
        transition: `transform ${offsetToTiming(offset)}ms cubic-bezier(0.300, 0.005, 0.425, 1.010)`
      }
      : {};

    return (
      <div ref={el => this.outer = el} className={classes(this.props.className, TextScrolling.styles.outer)}>
        <span ref={el => this.inner = el} className={TextScrolling.styles.inner} style={styles}>
          {this.props.children}
        </span>
      </div>
    )
  }

  componentDidMount() {
    setTimeout(this.reconfigure, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.children !== nextProps.children) {
      setTimeout(this.reconfigure, 0);
    }
  }

  componentWillUnmount() {
    this.clearInterval();
  }

  reconfigure = () => {
    const { width } = this.outer.getBoundingClientRect();
    const { scrollWidth } = this.outer;

    this.clearInterval();

    if (width < scrollWidth) {
      const offset = scrollWidth - width;
      this.setState({ scrolling: true, ltr: false, offset });
      this.interval = setInterval(() => this.setState({ ltr: !this.state.ltr }), offsetToTiming(offset) + 1000);
    } else {
      this.setState({ scrolling: false });
    }
  };

  clearInterval = () => {
    if (this.interval) {
      clearInterval(this.interval);
      delete this.interval;
    }
  };

  static styles = {
    outer: style({
      whiteSpace: 'pre',
      overflow: 'hidden'
    }),
    inner: style({
      display: 'inline-block'
    })
  }
}

function offsetToTiming(offset: number) {
  return offset * 100;
}